import { lightTheme } from '@/customTheme'
import Icons from '@/scenes/Editor/components/Icons'
import { ParagraphXSmall } from 'baseui/typography'
import { CSSProperties } from 'react'
import { useTranslation } from 'react-i18next'

interface SeeAllButtonProps {
  label?: string
  onClick?: () => void
  disabled?: boolean
  showArrow?: boolean
  style?: CSSProperties
}

/**
 * Standalone "See all" text action (pill-hover). Extracted from TitleWithSubAction
 * so it can be used on its own (e.g. beside a chips row) without a title.
 */
function SeeAllButton({
  label = 'See all',
  onClick,
  disabled = false,
  showArrow = false,
  style,
}: SeeAllButtonProps) {
  const [t] = useTranslation()

  return (
    <ParagraphXSmall
      onClick={disabled ? undefined : onClick}
      $style={{
        boxSizing: 'border-box',
        display: 'flex',
        alignItems: 'center',
        gap: '2px',
        cursor: disabled ? 'not-allowed' : 'pointer',
        padding: '0 8px',
        borderRadius: '12px',
        whiteSpace: showArrow ? 'nowrap' : undefined,
        ':hover': {
          background: disabled ? 'transparent' : showArrow ? lightTheme.colors.grayScale50 : lightTheme.colors.grayScale100,
        },
        ...lightTheme.typography.Small12medium,
        color: disabled ? lightTheme.colors.text.text_200_disable : lightTheme.colors.blackGray,
        pointerEvents: disabled ? 'none' : 'auto',
        ...style,
      }}
    >
      {t(label)}
      {showArrow && <Icons.RedArrowRight fill={lightTheme.colors.blackGray} />}
    </ParagraphXSmall>
  )
}

export default SeeAllButton
